import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const reviews = [
    {
        name: "Sarah M.",
        city: "Atlanta, GA",
        text: "Jefferson and his crew showed up on time and made our driveway look brand new. You can literally see the line between cleaned and dirty. Best money we've spent on our house in years.",
        rating: 5,
    },
    {
        name: "Marcus T.",
        city: "Marietta, GA",
        text: "I run a small restaurant — the storefront and patio get destroyed every week. Stronger Solutions handles it monthly now. Fast, professional, and the price is honest.",
        rating: 5,
    },
    {
        name: "Linda R.",
        city: "Decatur, GA",
        text: "I thought our siding was permanently stained. One soft-wash later and it looks like it did the day we moved in. They even cleaned a few extra spots without charging me.",
        rating: 5,
    },
    {
        name: "Devon K.",
        city: "Sandy Springs, GA",
        text: "Booked the windows + deck combo. Streak-free, no overspray on the plants, and the deck looks gorgeous. Already scheduled them for next spring.",
        rating: 5,
    },
];

export default function Testimonials() {
    return (
        <section
            id="reviews"
            data-testid="testimonials-section"
            className="relative py-24 lg:py-32 bg-[#fafbfc] border-t border-black/5"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
                <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
                    <div>
                        <div className="text-xs uppercase tracking-[0.3em] text-[#1E88E5] font-bold mb-4">
                            / Word On The Street
                        </div>
                        <h2 className="font-display font-bold uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-[#0a0a0a]">
                            Neighbors talk.
                            <br />
                            <span className="text-[#1E88E5]">We listen.</span>
                        </h2>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="flex">
                            {[1, 2, 3, 4, 5].map((i) => (
                                <Star
                                    key={i}
                                    className="w-5 h-5 fill-[#1E88E5] text-[#1E88E5]"
                                />
                            ))}
                        </div>
                        <div className="text-sm text-gray-600">
                            <span className="font-bold text-[#0a0a0a]">
                                5.0
                            </span>{" "}
                            average across 240+ reviews
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {reviews.map((r, i) => (
                        <motion.div
                            key={r.name}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.08 }}
                            className="relative bg-white border border-black/10 p-8 rounded-sm hover:border-[#1E88E5]/40 hover:shadow-lg transition-all"
                            data-testid={`review-card-${i}`}
                        >
                            <Quote className="absolute top-6 right-6 w-8 h-8 text-[#1E88E5]/20" />
                            <div className="flex mb-4">
                                {[...Array(r.rating)].map((_, j) => (
                                    <Star
                                        key={j}
                                        className="w-4 h-4 fill-[#1E88E5] text-[#1E88E5]"
                                    />
                                ))}
                            </div>
                            <p className="text-gray-700 leading-relaxed mb-6">
                                "{r.text}"
                            </p>
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#1E88E5] to-[#1565C0] flex items-center justify-center font-bold text-white text-sm">
                                    {r.name[0]}
                                </div>
                                <div>
                                    <div className="font-bold text-sm text-[#0a0a0a]">
                                        {r.name}
                                    </div>
                                    <div className="text-xs text-gray-500">
                                        {r.city}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
